import { Component, Input } from '@angular/core';

/**
 * Minimal, self-contained chrome for caregiver-facing error screens.
 *
 * Spec 051 (error-screen-parity), Phase 3 / FR-010 (independence).
 *
 * Error screens must render when the application whose failure they report is
 * unavailable. The shared `<app-header>` pulls in patient/auth/HTTP state and
 * can therefore fail (or itself route to an error screen), so error screens
 * must NOT use it. This layout renders only a static logo and projects the
 * screen body — it injects no services and depends on nothing that can fail.
 */
@Component({
  selector: 'app-error-screen-layout',
  standalone: true,
  imports: [],
  templateUrl: './error-screen-layout.component.html',
  styleUrl: './error-screen-layout.component.scss',
})
export class ErrorScreenLayoutComponent {
  /** Localized alt text for the logo image. */
  @Input() logoAlt = 'rettX';
}
